/**
 * Generic helpers for step-by-step navigation
 */

/**
 * Returns the next step in an ordered array of steps
 * @param {string} currentStep - The current step
 * @param {Array} steps - Ordered array of steps
 * @returns {string} The next step or the current step if it's the last one
 */
export const getNextStep = (currentStep, steps) => {
  const currentIndex = steps.indexOf(currentStep)
  if (currentIndex === -1 || currentIndex === steps.length - 1) {
    return currentStep
  }
  return steps[currentIndex + 1]
}

/**
 * Returns the previous step in an ordered array of steps
 * @param {string} currentStep - The current step
 * @param {Array} steps - Ordered array of steps
 * @returns {string} The previous step or the current step if it's the first one
 */
export const getPreviousStep = (currentStep, steps) => {
  const currentIndex = steps.indexOf(currentStep)
  if (currentIndex <= 0) {
    return currentStep
  }
  return steps[currentIndex - 1]
}
